// export const environment = {
//   production: true,
//   client_id: 'db5a9bd0-5e28-3cdb-bc4c-f0c133cf30da',
//   base_url: 'https://awslbgw.bancosemear.com.br/ddc/v1',
//   sdk_url: 'https://carnedigital.bancosemear.com.br/sdk-1.11.min.js',
//   endpoints: {
//     verifyToken: '/session/verifyToken',
//     simulacao: '/credito/simulacao',
//     proposta: '/credito/proposta',
//     viacep: 'https://viacep.com.br/ws',
//   },
//   localpoints: {
//     accessToken: '2d5fa5sad6as65df56asd56fd9d56af56sd56fsa56',
//     loading: '5as5d5sd6dsfa56fdsa56f564sdf8sfe56r45d5f5as5d5fa',
//     authResult: '2yy5t1546y5a6f6a48f8a84sdf5af18sdasf6s5dfas61f5',
//     params: '5d85d5fas4df56e55e5er15df5asd4fas6df5d5f85as6d54g6',
//     simulacao: '8d9fas8f8e5rer5e5r5e6afas3d2sd1f6s5ae8tw8r5efd3',
//     origin: 'kldkala09df9as7897d8a67sdf7a9sa9a9a9a99ad7f6a6sdf6as',
//     saltResult: '5d8d5a5d2d5af521as2f2asd12f11d1d1f2asd66a3s3s3d2f1',
//     response_result: '1d54d2d22a56d68r8r8r7t7qw66w6e3r22w22r1w166e',
//   },
//   body_encryption: {
//     key: 'qwr{@^h`h&_`50/ja9!&dcmh3!uw<&=?',
//     salt: '3456',
//   },
// };

export const environment = {
  production: true,
  client_id: 'db5a9bd0-5e28-3cdb-bc4c-f0c133cf30da',
  base_url: 'https://api.bancosemear.com.br/ddc/v1',
  sdk_url: 'https://carnedigital.bancosemear.com.br/sdk-2.3.min.js',
  endpoints: {
    verifyToken: '/session/verifyToken',
    simulacao: '/credito/simulacao',
    proposta: '/credito/proposta',
    viacep: 'https://viacep.com.br/ws',
  },
  localpoints: {
    accessToken: '2d5fa5sad6as65df56asd56fd9d56af56sd56fsa56',
    loading: '5as5d5sd6dsfa56fdsa56f564sdf8sfe56r45d5f5as5d5fa',
    authResult: '2yy5t1546y5a6f6a48f8a84sdf5af18sdasf6s5dfas61f5',
    params: '5d85d5fas4df56e55e5er15df5asd4fas6df5d5f85as6d54g6',
    simulacao: '8d9fas8f8e5rer5e5r5e6afas3d2sd1f6s5ae8tw8r5efd3',
    origin: 'kldkala09df9as7897d8a67sdf7a9sa9a9a9a99ad7f6a6sdf6as',
    saltResult: '5d8d5a5d2d5af521as2f2asd12f11d1d1f2asd66a3s3s3d2f1',
    response_result: '1d54d2d22a56d68r8r8r7t7qw66w6e3r22w22r1w166e',
  },
  body_encryption: {
    key: 'qwr{@^h`h&_`50/ja9!&dcmh3!uw<&=?',
    salt: '3456',
  },
};
